module.exports = __webpack_public_path__ + "img/talent7.dc543116.png";